// extracted by mini-css-extract-plugin
module.exports = {"item":"SectionsShimmer_item__2uPfj"};